import { render, staticRenderFns } from "./add_shoplist_user_pz.vue?vue&type=template&id=7abc974a&scoped=true&"
import script from "./add_shoplist_user_pz.vue?vue&type=script&lang=js&"
export * from "./add_shoplist_user_pz.vue?vue&type=script&lang=js&"
import style0 from "./add_shoplist_user_pz.vue?vue&type=style&index=0&id=7abc974a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abc974a",
  null
  
)

export default component.exports